module.exports = __webpack_public_path__ + "static/ML-4e878ef75e70374d39c5d0fe26727fa5.svg";